import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'DHAIRYA SUMMI',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'It is just simpilly awsome experience at fitclub and i really love it  ',
    name: 'PRIYA',
    status: 'COACH'
  },
  {
    image : image3,
    review:' I would really want to express my gratitude to fitclub which helped me a lot and the coaches here are soo kind and helpful they even give me the  ',
    name: 'VISHANK BHARDWAJ',
    status: "CUSTOMER"
  }
];
